import { render, staticRenderFns } from "./historico.vue?vue&type=template&id=b5e02772"
import script from "./historico.vue?vue&type=script&lang=js"
export * from "./historico.vue?vue&type=script&lang=js"
import style0 from "./historico.vue?vue&type=style&index=0&id=b5e02772&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports